import { Component } from '@angular/core';

@Component({
  selector: 'pm-tarjetas-list',
  templateUrl: './tarjetas-list.component.html',
  styleUrls: ['./tarjetas-list.component.sass']
})
export class TarjetasListComponent {
  public showTarjetas = true;
  public showAddTarjeta = false;
  public showEditTarjeta = false;
  public editnumber = 0;
}
